import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../App';

const PRIORITY_COLORS = { high: '#EF5350', medium: '#FF9800', low: '#4CAF50' };
const CAT_ICONS = { ecole: '🏫', sport: '⚽', medical: '💊', famille: '👨‍👩‍👧', admin: '📄', autre: '📌' };

const SAINTS = {'01-01':'Marie','01-02':'Basile','01-03':'Geneviève','01-04':'Odilon','01-05':'Édouard','01-06':'Melchior','01-07':'Raymond','01-08':'Lucien','01-09':'Alix','01-10':'Guillaume','01-11':'Paulin','01-12':'Tatiana','01-13':'Yvette','01-14':'Nina','01-15':'Rémi','01-16':'Marcel','01-17':'Roseline','01-18':'Prisca','01-19':'Marius','01-20':'Sébastien','01-21':'Agnès','01-22':'Vincent','01-23':'Barnard','01-24':'François de Sales','01-25':'Paul','01-26':'Timothée','01-27':'Angèle','01-28':'Thomas d\'Aquin','01-29':'Gildas','01-30':'Martine','01-31':'Marcelle','02-01':'Ella','02-02':'Présentation','02-03':'Blaise','02-04':'Véronique','02-05':'Agathe','02-06':'Gaston','02-07':'Eugénie','02-08':'Jacqueline','02-09':'Apolline','02-10':'Arnaud','02-11':'N-D de Lourdes','02-12':'Félix','02-13':'Béatrice','02-14':'Valentin','02-15':'Claude','02-16':'Julienne','02-17':'Alexis','02-18':'Bernadette','02-19':'Gabin','02-20':'Aimée','02-21':'Damien','02-22':'Isabelle','02-23':'Lazare','02-24':'Modeste','02-25':'Roméo','02-26':'Nestor','02-27':'Honorine','02-28':'Romain','02-29':'Auguste','03-01':'Aubin','03-02':'Charles le Bon','03-03':'Guénolé','03-04':'Casimir','03-05':'Olive','03-06':'Colette','03-07':'Félicité','03-08':'Jean de Dieu','03-09':'Françoise','03-10':'Vivien','03-11':'Rosine','03-12':'Justine','03-13':'Rodrigue','03-14':'Mathilde','03-15':'Louise','03-16':'Bénédicte','03-17':'Patrick','03-18':'Cyrille','03-19':'Joseph','03-20':'Herbert','03-21':'Clémence','03-22':'Léa','03-23':'Victorien','03-24':'Cath. de Suède','03-25':'Annonciation','03-26':'Larissa','03-27':'Habib','03-28':'Gontran','03-29':'Gwladys','03-30':'Amédée','03-31':'Benjamin','04-01':'Hugues','04-02':'Sandrine','04-03':'Richard','04-04':'Isidore','04-05':'Irène','04-06':'Marcellin','04-07':'Jean-Baptiste de la Salle','04-08':'Julie','04-09':'Gautier','04-10':'Fulbert','04-11':'Stanislas','04-12':'Jules','04-13':'Ida','04-14':'Maxime','04-15':'Paterne','04-16':'Benoît-Joseph','04-17':'Anicet','04-18':'Parfait','04-19':'Emma','04-20':'Odette','04-21':'Anselme','04-22':'Alexandre','04-23':'Georges','04-24':'Fidèle','04-25':'Marc','04-26':'Alida','04-27':'Zita','04-28':'Valérie','04-29':'Catherine de Sienne','04-30':'Robert','05-01':'Fête du Travail','05-02':'Boris','05-03':'Philippe','05-04':'Sylvain','05-05':'Judith','05-06':'Prudence','05-07':'Gisèle','05-08':'Victoire 1945','05-09':'Pacôme','05-10':'Solange','05-11':'Estelle','05-12':'Achille','05-13':'Rolande','05-14':'Matthias','05-15':'Denise','05-16':'Honoré','05-17':'Pascal','05-18':'Éric','05-19':'Yves','05-20':'Bernardin','05-21':'Constantin','05-22':'Rita','05-23':'Didier','05-24':'Donatien','05-25':'Sophie','05-26':'Bérenger','05-27':'Augustin','05-28':'Germain','05-29':'Aymar','05-30':'Ferdinand','05-31':'Visitation','06-01':'Justin','06-02':'Blandine','06-03':'Kévin','06-04':'Clotilde','06-05':'Igor','06-06':'Norbert','06-07':'Gilbert','06-08':'Médard','06-09':'Diane','06-10':'Landry','06-11':'Barnabé','06-12':'Guy','06-13':'Antoine de Padoue','06-14':'Élisée','06-15':'Germaine','06-16':'J-F Régis','06-17':'Hervé','06-18':'Léonce','06-19':'Romuald','06-20':'Silvère','06-21':'Rodolphe','06-22':'Alban','06-23':'Audrey','06-24':'Jean-Baptiste','06-25':'Prosper','06-26':'Anthelme','06-27':'Fernand','06-28':'Irénée','06-29':'Pierre & Paul','06-30':'Martial','07-01':'Thierry','07-02':'Martinien','07-03':'Thomas','07-04':'Florent','07-05':'Antoine','07-06':'Mariette','07-07':'Raoul','07-08':'Thibaut','07-09':'Amandine','07-10':'Ulrich','07-11':'Benoît','07-12':'Olivier','07-13':'Henri & Joël','07-14':'Fête Nationale','07-15':'Donald','07-16':'N-D du Carmel','07-17':'Charlotte','07-18':'Frédéric','07-19':'Arsène','07-20':'Marina','07-21':'Victor','07-22':'Marie-Madeleine','07-23':'Brigitte','07-24':'Christine','07-25':'Jacques','07-26':'Anne & Joachim','07-27':'Nathalie','07-28':'Samson','07-29':'Marthe','07-30':'Juliette','07-31':'Ignace de Loyola','08-01':'Alphonse','08-02':'Julien Eymard','08-03':'Lydie','08-04':'Jean-Marie Vianney','08-05':'Abel','08-06':'Transfiguration','08-07':'Gaétan','08-08':'Dominique','08-09':'Amour','08-10':'Laurent','08-11':'Claire','08-12':'Clarisse','08-13':'Hippolyte','08-14':'Evrard','08-15':'Assomption','08-16':'Armel','08-17':'Hyacinthe','08-18':'Hélène','08-19':'Jean-Eudes','08-20':'Bernard','08-21':'Christophe','08-22':'Fabrice','08-23':'Rose de Lima','08-24':'Barthélemy','08-25':'Louis','08-26':'Natacha','08-27':'Monique','08-28':'Augustin','08-29':'Sabine','08-30':'Fiacre','08-31':'Aristide','09-01':'Gilles','09-02':'Ingrid','09-03':'Grégoire','09-04':'Rosalie','09-05':'Raïssa','09-06':'Bertrand','09-07':'Reine','09-08':'Nativité','09-09':'Alain','09-10':'Inès','09-11':'Adelphe','09-12':'Apollinaire','09-13':'Aimé','09-14':'La Sainte Croix','09-15':'Roland','09-16':'Édith','09-17':'Renaud','09-18':'Nadège','09-19':'Émilie','09-20':'Davy','09-21':'Matthieu','09-22':'Maurice','09-23':'Constance','09-24':'Thècle','09-25':'Hermann','09-26':'Côme & Damien','09-27':'Vinc. de Paul','09-28':'Venceslas','09-29':'Michel','09-30':'Jérôme','10-01':'Thérèse de l\'Enfant-Jésus','10-02':'Léger','10-03':'Gérard','10-04':'François d\'Assise','10-05':'Fleur','10-06':'Bruno','10-07':'Serge','10-08':'Pélagie','10-09':'Denis','10-10':'Ghislain','10-11':'Firmin','10-12':'Wilfrid','10-13':'Géraud','10-14':'Juste','10-15':'Thérèse d\'Avila','10-16':'Edwige','10-17':'Baudouin','10-18':'Luc','10-19':'René','10-20':'Adeline','10-21':'Céline','10-22':'Élodie','10-23':'Jean de Capistran','10-24':'Florentin','10-25':'Crépin','10-26':'Dimitri','10-27':'Émeline','10-28':'Simon & Jude','10-29':'Narcisse','10-30':'Bienvenu','10-31':'Quentin','11-01':'Toussaint','11-02':'Défunts','11-03':'Hubert','11-04':'Charles','11-05':'Sylvie','11-06':'Bertille','11-07':'Carine','11-08':'Geoffrey','11-09':'Théodore','11-10':'Léon','11-11':'Martin','11-12':'Christian','11-13':'Brice','11-14':'Sidoine','11-15':'Albert','11-16':'Marguerite','11-17':'Élisabeth','11-18':'Aude','11-19':'Tanguy','11-20':'Edmond','11-21':'Prés. de Marie','11-22':'Cécile','11-23':'Clément','11-24':'Flora','11-25':'Catherine','11-26':'Delphine','11-27':'Sévrin','11-28':'Jacques de la Marche','11-29':'Saturnin','11-30':'André','12-01':'Florence','12-02':'Viviane','12-03':'François-Xavier','12-04':'Barbara','12-05':'Gérald','12-06':'Nicolas','12-07':'Ambroise','12-08':'Immaculée Conception','12-09':'Pierre Fourier','12-10':'Romaric','12-11':'Daniel','12-12':'Jeanne de Chantal','12-13':'Lucie','12-14':'Odile','12-15':'Ninon','12-16':'Alice','12-17':'Gaël','12-18':'Gatien','12-19':'Urbain','12-20':'Abraham','12-21':'Pierre Canisius','12-22':'Françoise-Xavière','12-23':'Armand','12-24':'Adèle','12-25':'Noël','12-26':'Étienne','12-27':'Jean','12-28':'Saints Innocents','12-29':'David','12-30':'Roger','12-31':'Sylvestre'};
function getTodaySaint() { const d = new Date(); return SAINTS[`${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`] || ''; }

// L'API renvoie les dates en "YYYY-MM-DD HH:MM:SS" (sans fuseau, mysql2 dateStrings:true).
// Ce format n'est pas garanti par la norme ISO (contrairement à "YYYY-MM-DDTHH:MM:SS") : selon
// le navigateur, il peut être interprété comme UTC au lieu d'heure locale, décalant l'affichage
// de +/-1 ou 2h (bug constaté le 13/09/2026 : un événement à 19h s'affichait à 17h). On force
// le séparateur 'T' pour que tous les moteurs JS le traitent comme une heure locale.
function parseApiDateTime(dt) {
  if (!dt) return null;
  return new Date(String(dt).replace(' ', 'T'));
}

function formatTime(dt) {
  if (!dt) return '';
  const d = parseApiDateTime(dt);
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

function formatDate(d) {
  return new Date(d + 'T00:00:00').toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
}

function MemberAvatar({ name, color, emoji, avatarUrl, size = 32 }) {
  if (avatarUrl) {
    return <img src={avatarUrl} alt={name} style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', border: `2px solid ${color}` }} />;
  }
  return (
    <div className="avatar" style={{ width: size, height: size, background: color + '22', color, fontSize: size * 0.5 }}>
      {emoji || name?.[0] || '?'}
    </div>
  );
}

function Section({ title, icon, count, children, empty }) {
  if (!children || (Array.isArray(children) && children.filter(Boolean).length === 0)) {
    return null;
  }
  return (
    <div>
      <div className="section-title">
        {icon} {title} {count != null && count > 0 && <span style={{ background: '#6C63FF', color: 'white', borderRadius: '50%', padding: '1px 6px', fontSize: 10, marginLeft: 4 }}>{count}</span>}
      </div>
      {children}
    </div>
  );
}

const RECURRENCE_LABELS = { une_fois: 'Une fois', quotidienne: 'Chaque jour', hebdomadaire: 'Chaque semaine', bimensuelle: 'Toutes les 2 sem.', mensuelle: 'Chaque mois' };

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [birthdays, setBirthdays] = useState([]);
  const [stickies, setStickies] = useState([]);
  const [aiSummary, setAiSummary] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [completingTask, setCompletingTask] = useState(null);
  const [editingTask, setEditingTask] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [savingTask, setSavingTask] = useState(false);

  const load = useCallback(() => {
    api.get('/dashboard').then(r => setData(r.data)).catch(console.error);
    api.get('/birthdays').then(r => setBirthdays(r.data.filter(b => b.days_until <= 0 && !b.wished))).catch(console.error);
    api.get('/stickies').then(r => setStickies(r.data.filter(s => !s.done))).catch(console.error);
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { window.addEventListener('family_refresh', load); return () => window.removeEventListener('family_refresh', load); }, [load]);

  const loadAiSummary = async () => {
    setAiLoading(true);
    try {
      const { data } = await api.get('/ai/summary');
      setAiSummary(data.summary);
    } catch { setAiSummary('Impossible de charger le résumé IA.'); }
    setAiLoading(false);
  };

  const wishBirthday = async (id) => {
    try {
      await api.patch(`/birthdays/${id}/wish`);
      load();
    } catch (e) { alert('Erreur : ' + (e.response?.data?.error || e.message)); }
  };

  const completeTask = async (taskId) => {
    setCompletingTask(taskId);
    try {
      await api.post(`/tasks/${taskId}/complete`, { user_id: user.id });
      load();
    } catch (e) { alert('Erreur : ' + (e.response?.data?.error || e.message)); }
    setCompletingTask(null);
  };

  const dismissThought = async (id) => {
    try { await api.put(`/thoughts/${id}/done`); load(); } catch { }
  };

  const dismissReminder = async (id) => {
    try { await api.put(`/reminders/${id}/done`); load(); } catch { }
  };

  const openTask = (task) => {
    setEditForm({
      title: task.title, icon: task.icon || '✅', category: task.category || 'autre',
      recurrence: task.recurrence || 'une_fois', next_due: task.next_due || '',
      due_time: task.due_time ? task.due_time.substring(0, 5) : '',
      assigned_to: task.assigned_to || '', priority: task.priority || 'medium',
      due_scope: task.due_scope || '', recurrence_months: task.recurrence_months || '',
      notes: task.notes || ''
    });
    setEditingTask(task);
  };

  const saveTask = async () => {
    setSavingTask(true);
    try {
      const payload = { ...editForm, assigned_to: editForm.assigned_to || null, recurrence_months: editForm.recurrence_months || null };
      await api.put(`/tasks/${editingTask.id}`, payload);
      setEditingTask(null);
      load();
    } catch (e) { alert(e.response?.data?.error || e.message); }
    setSavingTask(false);
  };

  const deleteTask = async () => {
    if (!window.confirm(`Supprimer la tâche "${editingTask.title}" ?`)) return;
    await api.delete(`/tasks/${editingTask.id}`);
    setEditingTask(null);
    load();
  };

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Bonjour';
    if (h < 18) return 'Bon après-midi';
    return 'Bonsoir';
  };

  const todayFull = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  if (!data) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div className="spinner" style={{ width: 40, height: 40 }} />
    </div>
  );

  const { events, tasks, tasksWeek, tasksMonth, birthdaysToday, thoughts, shopping, meals, reminders, upcoming, members, taskLoad, emailsToTreat } = data;

  const overdueTasks = tasks.filter(t => t.next_due && t.next_due < data.today);
  const todayTasksList = tasks.filter(t => t.next_due === data.today);
  const noDateTasksList = tasks.filter(t => !t.next_due && !t.due_scope);

  const maxLoad = Math.max(...(taskLoad || []).map(t => t.count), 1);

  return (
    <div>
      {/* TOPBAR */}
      <div className="topbar">
        <div className="topbar-logo">🏠 FamilyOS</div>
        <div className="topbar-actions">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            <MemberAvatar name={user.name} color={user.color} emoji={user.avatar_emoji} avatarUrl={user.avatar_url} />
            <button className="btn btn-ghost btn-sm" onClick={logout} title="Déconnexion" style={{ padding: '4px 8px' }}>⎋</button>
          </div>
        </div>
      </div>

      <div className="page" style={{ paddingTop: 0 }}>
        {/* HERO */}
        <div className="dashboard-hero">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="hero-greeting">{greeting()},</div>
              <div className="hero-name" style={{ margin: 0 }}>{user.name}</div>
              <div className="hero-date" style={{ textTransform: 'capitalize' }}>{todayFull}</div>
              <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>🙏 Fête : {getTodaySaint()}</div>
              {stickies.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 8 }}>
                  {stickies.slice(0, 3).map(s => (
                    <div key={s.id} style={{ background: s.color || '#FFE082', borderRadius: 8, padding: '5px 9px', fontSize: 11, fontWeight: 700, color: '#333', lineHeight: 1.3 }}>
                      📝 {s.content}
                    </div>
                  ))}
                  {stickies.length > 3 && (
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.7)', textAlign: 'right' }}>+{stickies.length - 3} note{stickies.length - 3 > 1 ? 's' : ''}</div>
                  )}
                </div>
              )}
            </div>
            {user.avatar_url
              ? <img src={user.avatar_url} alt={user.name} style={{ width: 90, height: 90, borderRadius: '50%', objectFit: 'cover', border: '3px solid rgba(255,255,255,0.6)', flexShrink: 0 }} />
              : <span style={{ fontSize: 64, flexShrink: 0 }}>{user.avatar_emoji}</span>
            }
          </div>

          {!aiSummary && (
            <button onClick={loadAiSummary} disabled={aiLoading}
              style={{ marginTop: 14, background: 'rgba(255,255,255,0.18)', border: '1.5px solid rgba(255,255,255,0.5)', color: 'white', borderRadius: 14, padding: '12px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontFamily: 'inherit', width: '100%', minHeight: 46 }}>
              {aiLoading ? <><span className="spinner" style={{ width: 16, height: 16, borderColor: 'rgba(255,255,255,0.3)', borderTopColor: 'white' }} /> Génération en cours…</> : '✨ Voir le résumé IA de la journée'}
            </button>
          )}

          {aiSummary && (
            <div style={{ marginTop: 14, background: 'rgba(255,255,255,0.15)', borderRadius: 14, padding: '12px 14px' }}>
              <div style={{ fontSize: 13, lineHeight: 1.8, color: 'white', whiteSpace: 'pre-line' }}>{aiSummary}</div>
              <button onClick={() => setAiSummary('')}
                style={{ marginTop: 10, width: '100%', background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.4)', color: 'white', borderRadius: 10, padding: '10px 0', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', minHeight: 42 }}>
                ✕ Fermer le résumé
              </button>
            </div>
          )}

          {events.length === 0 && todayTasksList.length === 0 && overdueTasks.length === 0 && noDateTasksList.length === 0 && (
            <div style={{ marginTop: 14, background: 'rgba(255,255,255,0.15)', borderRadius: 14, padding: '12px 16px', textAlign: 'center' }}>
              <div style={{ fontSize: 20, marginBottom: 4 }}>🌿</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: 'white' }}>Profitez, plus rien à faire aujourd'hui !</div>
            </div>
          )}
        </div>

        {/* STATS RAPIDES */}
        <div className="stat-grid">
          <div className="stat-card">
            <div className="stat-icon">📅</div>
            <div className="stat-value" style={{ color: '#6C63FF' }}>{events.length}</div>
            <div className="stat-label">Événement{events.length !== 1 ? 's' : ''} aujourd'hui</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">✅</div>
            <div className="stat-value" style={{ color: todayTasksList.filter(t => t.priority === 'high').length > 0 ? '#EF5350' : '#4CAF50' }}>{todayTasksList.length}</div>
            <div className="stat-label">Tâche{todayTasksList.length !== 1 ? 's' : ''} aujourd'hui</div>
          </div>
        </div>

        {/* ANNIVERSAIRES 7 JOURS */}
        {birthdays.length > 0 && (
          <Section title="Anniversaires" icon="🎂" count={birthdays.filter(b => b.days_until <= 0).length || null}>
            {birthdays.map(b => {
              const late = b.days_until < 0;
              const borderColor = late ? '#FF9800' : b.days_until === 0 ? '#EF5350' : '#6C63FF';
              const dayLabel = late
                ? `${Math.abs(b.days_until)} jour${Math.abs(b.days_until) > 1 ? 's' : ''} de retard`
                : b.days_until === 0 ? "Aujourd'hui" : b.days_until === 1 ? 'Demain' : `Dans ${b.days_until} jours`;
              return (
                <div key={b.id} className="card" onClick={() => navigate('/anniversaires')} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderLeft: `4px solid ${borderColor}`, cursor: 'pointer' }}>
                  <span style={{ fontSize: 26 }}>{late ? '⏰' : b.days_until === 0 ? '🎉' : '🎂'}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 14 }}>{b.name}</div>
                    <div style={{ fontSize: 12, color: late ? '#FF9800' : '#8888AA', fontWeight: late ? 700 : 400 }}>
                      {late ? `(${dayLabel})` : dayLabel}
                    </div>
                  </div>
                  <button
                    onClick={e => { e.stopPropagation(); wishBirthday(b.id); }}
                    style={{ background: '#6C63FF', color: 'white', border: 'none', borderRadius: 20, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}
                  >✓ Souhaité</button>
                </div>
              );
            })}
          </Section>
        )}

        {/* RAPPELS IMMINENTS */}
        {reminders.length > 0 && (
          <Section title="Rappels" icon="⏰" count={reminders.length}>
            {reminders.map(r => {
              const now = new Date();
              const remindAt = parseApiDateTime(r.remind_at);
              const remindDay = new Date(remindAt); remindDay.setHours(0,0,0,0);
              const todayDay = new Date(); todayDay.setHours(0,0,0,0);
              const tomorrowDay = new Date(todayDay); tomorrowDay.setDate(todayDay.getDate() + 1);
              const isTodayRemind = remindDay.getTime() === todayDay.getTime();
              const isTomorrowRemind = remindDay.getTime() === tomorrowDay.getTime();
              let displayTitle = r.title;
              if (r.title.includes("Dans 2h")) {
                // remind_at = eventTime - 2h → eventTime = remind_at + 2h
                const eventTime = new Date(remindAt.getTime() + 2 * 60 * 60 * 1000);
                const diffH = Math.round((eventTime - now) / (1000 * 60 * 60));
                const taskName = r.title.replace(/^.*Dans 2h\s*:\s*/, '');
                if (diffH <= 2) displayTitle = r.title;
                else if (diffH < 24) displayTitle = r.title.replace('Dans 2h', `Dans ${diffH}h`);
                else {
                  const dateLabel = isTomorrowRemind
                    ? `demain à ${eventTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
                    : `le ${eventTime.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })} à ${eventTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
                  displayTitle = r.title.replace('Dans 2h', `Prévu ${dateLabel}`).replace(/^[^\s]+\s/, '');
                }
              } else if (r.title.includes("À faire aujourd'hui") && !isTodayRemind) {
                displayTitle = r.title.replace(
                  "À faire aujourd'hui",
                  isTomorrowRemind
                    ? "À faire demain"
                    : `À faire le ${remindDay.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}`
                );
              } else if (r.title.includes("⏰ Demain") && !isTomorrowRemind && !isTodayRemind) {
                displayTitle = r.title.replace(
                  "⏰ Demain",
                  `⏰ Le ${remindDay.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}`
                );
              }
              return (
                <div key={r.id} className="reminder-item" onClick={() => navigate('/taches')} style={{ cursor: 'pointer' }}>
                  <span style={{ fontSize: 18 }}>⏰</span>
                  <div style={{ flex: 1 }}>
                    <div className="reminder-text">{displayTitle}</div>
                    {r.message && <div className="text-muted" style={{ fontSize: 11, marginTop: 2 }}>{r.message}</div>}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                    <span className="reminder-time">{parseApiDateTime(r.remind_at).toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                    <button className="btn btn-ghost btn-sm" onClick={e => { e.stopPropagation(); dismissReminder(r.id); }} style={{ padding: '2px 8px', fontSize: 11 }}>Vu ✓</button>
                  </div>
                </div>
              );
            })}
          </Section>
        )}

        {/* EMAILS À TRAITER */}
        {emailsToTreat && emailsToTreat.length > 0 && (
          <Section title="Emails à traiter" icon="📧" count={emailsToTreat.length}>
            {emailsToTreat.map(e => (
              <div key={e.id} className="card" onClick={() => navigate('/emails', { state: { filter: 'to_treat' } })} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderLeft: '4px solid #FF9800', cursor: 'pointer' }}>
                <span style={{ fontSize: 22 }}>📧</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.subject}</div>
                  <div style={{ fontSize: 11, color: '#8888AA', marginTop: 2 }}>{e.from_name || e.from_address}</div>
                </div>
                <div style={{ fontSize: 11, color: '#FF9800', fontWeight: 700, whiteSpace: 'nowrap' }}>
                  {new Date(e.received_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}
                </div>
              </div>
            ))}
          </Section>
        )}

        {/* ÉVÉNEMENTS DU JOUR */}
        {events.length > 0 && (
          <Section title="Aujourd'hui" icon="📅" count={events.length}>
            <div className="card" style={{ padding: '8px 16px' }}>
              {events.map(ev => (
                <div key={ev.id} className="event-item" onClick={() => navigate('/agenda')} style={{ cursor: 'pointer' }}>
                  <div className="event-time">{ev.all_day ? 'Jour' : formatTime(ev.start_datetime)}</div>
                  <div className="event-dot" style={{ background: ev.user_color || '#6C63FF' }} />
                  <div style={{ flex: 1 }}>
                    <div className="event-title">{ev.title}</div>
                    {ev.location && <div className="text-muted" style={{ fontSize: 11 }}>📍 {ev.location}</div>}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {ev.user_name && <span style={{ fontSize: 11, color: '#8888AA' }}>{ev.avatar_emoji}</span>}
                    <span style={{ fontSize: 14 }}>{CAT_ICONS[ev.category] || '📌'}</span>
                  </div>
                </div>
              ))}
            </div>
          </Section>
        )}

        {/* TÂCHES EN RETARD */}
        {overdueTasks.length > 0 && (
          <Section title="En retard" icon="⚠️" count={overdueTasks.length}>
            {overdueTasks.map(task => (
              <div key={task.id} className="task-item" style={{ opacity: completingTask === task.id ? 0.5 : 1, borderLeft: '4px solid #EF5350' }}>
                <div className="task-priority-bar" style={{ background: '#EF5350' }} />
                <button className="task-check" onClick={() => completeTask(task.id)} disabled={completingTask === task.id} title="Marquer comme fait">
                  {completingTask === task.id ? <span className="spinner" style={{ width: 12, height: 12 }} /> : ''}
                </button>
                <span className="task-icon">{task.icon || '✅'}</span>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => openTask(task)}>
                  <div className="task-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{task.title}</div>
                  <div className="task-meta">
                    <span style={{ color: '#EF5350', fontWeight: 700, marginRight: 6 }}>⚠️ {formatDate(task.next_due)}{task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}</span>
                    {task.assigned_name && <span>{task.avatar_emoji} {task.assigned_name}</span>}
                    {task.recurrence !== 'une_fois' && <span style={{ marginLeft: 4 }}>🔄</span>}
                  </div>
                </div>
                {task.priority === 'high' && <span className="badge badge-urgent">!</span>}
              </div>
            ))}
          </Section>
        )}

        {/* TÂCHES À FAIRE AUJOURD'HUI */}
        {todayTasksList.length > 0 && (
          <Section title="À faire aujourd'hui" icon="✅" count={todayTasksList.length}>
            {todayTasksList.map(task => {
              const isOverdue = false;
              const isToday = task.next_due === data.today;
              return (
                <div key={task.id} className="task-item" style={{ opacity: completingTask === task.id ? 0.5 : 1 }}>
                  <div className="task-priority-bar" style={{ background: PRIORITY_COLORS[task.priority] || '#E0E4F0' }} />
                  <button className="task-check" onClick={() => completeTask(task.id)} disabled={completingTask === task.id} title="Marquer comme fait">
                    {completingTask === task.id ? <span className="spinner" style={{ width: 12, height: 12 }} /> : ''}
                  </button>
                  <span className="task-icon">{task.icon || '✅'}</span>
                  <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => openTask(task)}>
                    <div className="task-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{task.title}</div>
                    <div className="task-meta">
                      {isOverdue && <span style={{ color: '#EF5350', marginRight: 6 }}>⚠️ {formatDate(task.next_due)}{task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}</span>}
                      {isToday && !isOverdue && <span style={{ color: '#FF9800', marginRight: 6 }}>📅 Aujourd'hui{task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}</span>}
                      {!isOverdue && !isToday && task.next_due && <span style={{ color: '#8888AA', marginRight: 6 }}>📅 {formatDate(task.next_due)}{task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}</span>}
                      {task.assigned_name && <span>{task.avatar_emoji} {task.assigned_name}</span>}
                      {task.recurrence !== 'une_fois' && <span style={{ marginLeft: 4 }}>🔄</span>}
                    </div>
                  </div>
                  {task.priority === 'high' && <span className="badge badge-urgent">!</span>}
                </div>
              );
            })}
          </Section>
        )}

        {/* TÂCHES SANS DATE */}
        {noDateTasksList.length > 0 && (
          <Section title="À faire" icon="📋" count={noDateTasksList.length}>
            {noDateTasksList.map(task => (
              <div key={task.id} className="task-item" style={{ opacity: completingTask === task.id ? 0.5 : 1 }}>
                <div className="task-priority-bar" style={{ background: PRIORITY_COLORS[task.priority] || '#E0E4F0' }} />
                <button className="task-check" onClick={() => completeTask(task.id)} disabled={completingTask === task.id} title="Marquer comme fait">
                  {completingTask === task.id ? <span className="spinner" style={{ width: 12, height: 12 }} /> : ''}
                </button>
                <span className="task-icon">{task.icon || '✅'}</span>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => openTask(task)}>
                  <div className="task-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{task.title}</div>
                  <div className="task-meta">
                    <span style={{ color: '#8888AA', marginRight: 6 }}>Sans échéance</span>
                    {task.assigned_name && <span>{task.avatar_emoji} {task.assigned_name}</span>}
                  </div>
                </div>
                {task.priority === 'high' && <span className="badge badge-urgent">!</span>}
              </div>
            ))}
          </Section>
        )}

        {/* TÂCHES CETTE SEMAINE */}
        {tasksWeek && tasksWeek.length > 0 && (
          <Section title="Tâches cette semaine" icon="📆" count={tasksWeek.length}>
            {tasksWeek.map(task => (
              <div key={task.id} className="task-item">
                <div className="task-priority-bar" style={{ background: PRIORITY_COLORS[task.priority] || '#E0E4F0' }} />
                <button className="task-check" onClick={() => completeTask(task.id)} disabled={completingTask === task.id} title="Marquer comme fait">
                  {completingTask === task.id ? <span className="spinner" style={{ width: 12, height: 12 }} /> : ''}
                </button>
                <span className="task-icon">{task.icon || '✅'}</span>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => openTask(task)}>
                  <div className="task-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{task.title}</div>
                  <div className="task-meta">
                    <span style={{ color: '#6C63FF', marginRight: 6 }}>
                      {task.due_scope === 'week' ? '📅 Cette semaine' : `📅 ${formatDate(task.next_due)}`}
                      {task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}
                    </span>
                    {task.assigned_name && <span>{task.avatar_emoji} {task.assigned_name}</span>}
                    {task.recurrence !== 'une_fois' && <span style={{ marginLeft: 4 }}>🔄</span>}
                    {task.recurrence === 'une_fois' && task.recurrence_months > 0 && <span style={{ marginLeft: 4, color: '#8888AA', fontSize: 10 }}>↻ {task.recurrence_months} mois</span>}
                  </div>
                </div>
              </div>
            ))}
          </Section>
        )}

        {/* TÂCHES CE MOIS */}
        {tasksMonth && tasksMonth.length > 0 && (
          <Section title="Tâches ce mois" icon="🗓️" count={tasksMonth.length}>
            {tasksMonth.map(task => (
              <div key={task.id} className="task-item">
                <div className="task-priority-bar" style={{ background: PRIORITY_COLORS[task.priority] || '#E0E4F0' }} />
                <button className="task-check" onClick={() => completeTask(task.id)} disabled={completingTask === task.id} title="Marquer comme fait">
                  {completingTask === task.id ? <span className="spinner" style={{ width: 12, height: 12 }} /> : ''}
                </button>
                <span className="task-icon">{task.icon || '✅'}</span>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => openTask(task)}>
                  <div className="task-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{task.title}</div>
                  <div className="task-meta">
                    <span style={{ color: '#8888AA', marginRight: 6 }}>
                      {task.due_scope === 'month' ? '🗓️ Ce mois-ci' : `📅 ${formatDate(task.next_due)}`}
                      {task.due_time ? ` · ⏰ ${task.due_time.substring(0,5)}` : ''}
                    </span>
                    {task.assigned_name && <span>{task.avatar_emoji} {task.assigned_name}</span>}
                    {task.recurrence !== 'une_fois' && <span style={{ marginLeft: 4 }}>🔄</span>}
                    {task.recurrence === 'une_fois' && task.recurrence_months > 0 && <span style={{ marginLeft: 4, color: '#8888AA', fontSize: 10 }}>↻ {task.recurrence_months} mois</span>}
                  </div>
                </div>
              </div>
            ))}
          </Section>
        )}


        {/* REPAS DU SOIR */}
        {meals.length > 0 && (
          <Section title="Au menu ce soir" icon="🍽️">
            <div className="card" onClick={() => navigate('/repas')} style={{ display: 'flex', gap: 12, alignItems: 'center', cursor: 'pointer' }}>
              <span style={{ fontSize: 36 }}>🍽️</span>
              <div>
                {meals.map(m => (
                  <div key={m.id}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#1A1A2E' }}>{m.title}</div>
                    {m.description && <div className="text-muted">{m.description}</div>}
                    {m.ingredients && <div style={{ fontSize: 11, color: '#8888AA', marginTop: 4 }}>🥕 {m.ingredients}</div>}
                  </div>
                ))}
              </div>
            </div>
          </Section>
        )}

        {/* CETTE SEMAINE */}
        {upcoming.length > 0 && (
          <Section title="Calendrier cette semaine" icon="📅" count={upcoming.length}>
            <div className="card" style={{ padding: '8px 16px' }}>
              {upcoming.slice(0, 6).map(ev => (
                <div key={ev.id} className="event-item" onClick={() => navigate('/agenda')} style={{ cursor: 'pointer' }}>
                  <div style={{ minWidth: 56, fontSize: 12, color: '#6C63FF', fontWeight: 700 }}>
                    {parseApiDateTime(ev.start_datetime).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' })}
                  </div>
                  <div className="event-dot" style={{ background: ev.user_color || '#6C63FF' }} />
                  <div className="event-title" style={{ fontSize: 13 }}>{ev.title}</div>
                  {ev.avatar_emoji && <span style={{ fontSize: 14 }}>{ev.avatar_emoji}</span>}
                </div>
              ))}
            </div>
          </Section>
        )}


        {/* ÉTAT VIDE */}
        {events.length === 0 && todayTasksList.length === 0 && overdueTasks.length === 0 && (!tasksWeek || tasksWeek.length === 0) && (!tasksMonth || tasksMonth.length === 0) && (!birthdaysToday || birthdaysToday.length === 0) && (
          <div className="card" style={{ textAlign: 'center', padding: 32, marginTop: 8 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✨</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#6C63FF', marginBottom: 8 }}>Journée libre !</div>
            <div className="text-muted">Rien de prévu et aucune tâche en attente.<br />Profitez-en !</div>
          </div>
        )}

        {/* COURSES RAPIDES — masquées sur la page d'accueil */}
        {false && shopping.length > 0 && (
          <Section title={`À acheter (${shopping.length})`} icon="🛒">
            <div className="card" style={{ padding: '8px 16px' }}>
              {shopping.slice(0, 5).map(s => (
                <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: '1px solid #F0F2FF' }}>
                  <span style={{ fontSize: 13, flex: 1, fontWeight: 500 }}>{s.name}</span>
                  {s.quantity && <span style={{ fontSize: 11, color: '#8888AA' }}>{s.quantity}</span>}
                  <span className="shopping-cat" style={{ fontSize: 10 }}>{s.category}</span>
                </div>
              ))}
              {shopping.length > 5 && <div className="text-muted text-center mt-8" style={{ fontSize: 12 }}>+ {shopping.length - 5} autre{shopping.length - 5 > 1 ? 's' : ''}</div>}
            </div>
          </Section>
        )}

        <div style={{ height: 8 }} />
      </div>

      {/* MODAL ÉDITION TÂCHE */}
      {editingTask && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setEditingTask(null)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">✏️ {editingTask.title}</div>

            <div className="form-group">
              <label className="form-label">Titre</label>
              <input className="form-input" value={editForm.title} onChange={e => setEditForm({ ...editForm, title: e.target.value })} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group">
                <label className="form-label">Priorité</label>
                <select className="form-input" value={editForm.priority} onChange={e => setEditForm({ ...editForm, priority: e.target.value })}>
                  <option value="low">🟢 Faible</option>
                  <option value="medium">🟡 Normal</option>
                  <option value="high">🔴 Urgent</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Assigné à</label>
                <select className="form-input" value={editForm.assigned_to} onChange={e => setEditForm({ ...editForm, assigned_to: e.target.value })}>
                  <option value="">— Tous —</option>
                  {(members || []).map(m => <option key={m.id} value={m.id}>{m.avatar_emoji} {m.name}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group">
                <label className="form-label">Pour le</label>
                <input type="date" className="form-input" value={editForm.next_due} onChange={e => setEditForm({ ...editForm, next_due: e.target.value, due_scope: '' })} />
              </div>
              <div className="form-group">
                <label className="form-label">⏰ Heure</label>
                <input type="time" className="form-input" value={editForm.due_time} onChange={e => setEditForm({ ...editForm, due_time: e.target.value })} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group">
                <label className="form-label">Récurrence</label>
                <select className="form-input" value={editForm.recurrence} onChange={e => setEditForm({ ...editForm, recurrence: e.target.value })}>
                  <option value="une_fois">Une fois</option>
                  <option value="quotidienne">Chaque jour</option>
                  <option value="hebdomadaire">Chaque semaine</option>
                  <option value="bimensuelle">Toutes les 2 sem.</option>
                  <option value="mensuelle">Chaque mois</option>
                </select>
              </div>
              {editForm.recurrence === 'une_fois' && (
                <div className="form-group">
                  <label className="form-label">↻ Tous les X mois</label>
                  <select className="form-input" value={editForm.recurrence_months} onChange={e => setEditForm({ ...editForm, recurrence_months: e.target.value })}>
                    <option value="">Aucun</option>
                    <option value="1">1 mois</option>
                    <option value="2">2 mois</option>
                    <option value="3">3 mois</option>
                    <option value="6">6 mois</option>
                    <option value="12">12 mois</option>
                    <option value="24">24 mois</option>
                  </select>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn btn-danger btn-sm" onClick={deleteTask}>🗑️</button>
              <button className="btn btn-ghost" onClick={() => setEditingTask(null)} style={{ flex: 1 }}>Annuler</button>
              <button className="btn btn-primary" onClick={saveTask} disabled={savingTask || !editForm.title.trim()} style={{ flex: 2 }}>
                {savingTask ? <span className="spinner" style={{ width: 16, height: 16 }} /> : '✓ Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
